import useSelectUser from 'hooks/use-select-user';

export default function () {
  const user = useSelectUser();
  
  return user && user.isAdmin === true;
}
